export const cropAndResizeProfileImage = (file, callback) => {
    const reader = new FileReader();
    reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
            const side = Math.min(img.width, img.height); // square crop
            const startX = (img.width - side) / 2;
            const startY = (img.height - side) / 2;

            const canvas = document.createElement('canvas');
            canvas.width = 300;
            canvas.height = 300;
            const ctx = canvas.getContext('2d');

            ctx.drawImage(
                img,
                startX, startY, side, side,  // crop center
                0, 0, 300, 300               // resize to 300x300
            );

            const base64 = canvas.toDataURL('image/jpeg', 1.0); // highest quality
            callback(base64);
        };
        img.src = e.target.result;
    };
    reader.readAsDataURL(file);
};

export const resizeImagePreview = (
    file,
    callback,
    size = 300,
) => {
    const reader = new FileReader();

    reader.onload = (e) => {
        const img = new Image();

        img.onload = () => {
            const side = Math.min(img.width, img.height);

            const startX = (img.width - side) / 2;
            const startY = (img.height - side) / 2;

            const canvas = document.createElement("canvas");
            canvas.width = size;
            canvas.height = size;

            const ctx = canvas.getContext("2d");

            ctx.drawImage(
                img,
                startX,
                startY,
                side,
                side,
                0,
                0,
                size,
                size
            );

            callback(canvas.toDataURL("image/jpeg", 1.0));
        };

        img.src = e.target.result;
    };

    reader.readAsDataURL(file);
};

export const resizeServiceImagePreview = (file, callback) => {
    const reader = new FileReader();

    reader.onload = (e) => {
        const img = new Image();

        img.onload = () => {
            const size = 120; // 🔥 preview size

            // square crop (center)
            const side = Math.min(img.width, img.height);
            const sx = (img.width - side) / 2;
            const sy = (img.height - side) / 2;

            const canvas = document.createElement("canvas");
            canvas.width = size;
            canvas.height = size;

            const ctx = canvas.getContext("2d");

            ctx.drawImage(
                img,
                sx, sy, side, side, // source crop
                0, 0, size, size    // resize to 120x120
            );

            const base64 = canvas.toDataURL("image/jpeg", 0.9);
            callback(base64);
        };

        img.src = e.target.result;
    };

    reader.readAsDataURL(file);
};